import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 mt-32" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-20 grid grid-cols-2 md:grid-cols-4 gap-12">
        <div className="col-span-2 md:col-span-1">
          <h3 className="serif text-3xl tracking-tight">Velora</h3>
          <p className="mt-4 text-sm text-muted-foreground font-light leading-relaxed">
            A quiet luxury house. Considered garments, built to outlast trend.
          </p>
        </div>
        <div>
          <div className="overline text-muted-foreground">Shop</div>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/shop/women" className="hover:text-muted-foreground">Women</Link></li>
            <li><Link to="/shop/men" className="hover:text-muted-foreground">Men</Link></li>
            <li><Link to="/shop/accessories" className="hover:text-muted-foreground">Accessories</Link></li>
            <li><Link to="/shop" className="hover:text-muted-foreground">The Edit</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-muted-foreground">Atelier</div>
          <ul className="mt-5 space-y-3 text-sm text-muted-foreground">
            <li>Our Story</li>
            <li>Craftsmanship</li>
            <li>Sustainability</li>
            <li>Journal</li>
          </ul>
        </div>
        <div>
          <div className="overline text-muted-foreground">Service</div>
          <ul className="mt-5 space-y-3 text-sm text-muted-foreground">
            <li>Shipping</li>
            <li>Returns</li>
            <li>Care Guide</li>
            <li>Contact</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-muted-foreground tracking-[0.18em] uppercase">
          <div>© 2026 Velora. All rights reserved.</div>
          <div className="flex gap-6"><span>Privacy</span><span>Terms</span><Link to="/admin" data-testid="footer-admin-link">Admin</Link></div>
        </div>
      </div>
    </footer>
  );
};
